import Dexie from 'dexie'
import { IDBKeyRange as inMemoryIDBKeyRange, indexedDB as inMemoryDb } from 'fake-indexeddb'

export const iDBSupported = 'indexedDB' in window

export class InPersonMeetingDb extends Dexie {
  file_parts!: Dexie.Table<FilePart, number>
  constructor() {
    super('InPersonMeetingDb', {
      indexedDB: iDBSupported ? window.indexedDB : inMemoryDb,
      IDBKeyRange: iDBSupported ? window.IDBKeyRange : inMemoryIDBKeyRange,
    })

    this.version(1).stores({
      file_parts: '++id, accountId, roomId, sessionId, name, date, fileContent, mimeType, size, sort',
    })
    this.version(2).stores({
      file_parts: '++id, [accountId+roomId+sessionId], name, date, fileContent, mimeType, size, sort',
    })
    this.version(3).stores({
      file_parts: '++id, [accountId+roomId+sessionId], sort',
    })
  }
}

export interface FilePart {
  id?: number
  accountId: string
  roomId: string
  sessionId: string
  name: string
  createdAt: string
  fileContent: ArrayBuffer
  mimeType: string
  size: number
  sort: number
}

export const db = new InPersonMeetingDb()

export const blobToArrayBuffer = (blob: Blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.addEventListener('loadend', () => {
      resolve(reader.result)
    })
    reader.addEventListener('error', reject)
    reader.readAsArrayBuffer(blob)
  })
}
